import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import InputField from '../Reusable/InputField';
import { SubmitButton } from '../../enums/GlobalEnums';
import { ModalForAddOrUpdateProductCategory } from '../../enums/ProductCategoryEnums';

const ModalForAddProductCategory = ({
  handleAdd,
  handleClose,
  show,
  productCategoryReducer,
}) => {
 const [productCategoryName, setProductCategoryName] = useState('');
  const { error } = productCategoryReducer;

  const onChange = (e) => {
    setProductCategoryName(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const newProductCategory = {
      productCategoryName,
    };
    handleAdd(newProductCategory);
  };

  return (
    <Dialog open={show} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        {ModalForAddOrUpdateProductCategory.titleForAddProductCategory}
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{ position: 'absolute', right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <InputField
          name="productCategoryName"
          placeholder={ModalForAddOrUpdateProductCategory.productCategoryNamePlaceholder}
          onChange={onChange}
          value={productCategoryName}
          error={error?.productCategoryName}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleSubmit} variant="contained" color="primary">
          {SubmitButton.save}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModalForAddProductCategory;
